// Section layout tokens, aligned with the MUI theme's 8px spacing unit:
// 2rem = theme.spacing(4), 1rem = theme.spacing(2). Shared between the Section
// component and the MuiContainer style override so the max-width and gutters
// stay in sync.
export const SECTION_MAX_WIDTH = '1280px';
export const SECTION_PADDING_INLINE = '2rem'; // desktop/tablet
export const SECTION_PADDING_INLINE_MOBILE = '1rem'; // <600px (sm)
